<template>
  <PageContainer class="overflow-auto">
    <a-breadcrumb :separator="separator">
      <a-breadcrumb-item>
        <nuxt-link :to="{ name: PageKey.CENTER_ORDER }">
          {{ $t('ding-dan-fa-piao') }}
        </nuxt-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        {{ route.query.id ? $t('kai-piao') : $t('pi-liang-kai-piao') }}
      </a-breadcrumb-item>
    </a-breadcrumb>
    <div class="mt-[20px] overflow-auto">
      <a-alert show-icon>
        <template #message>
          <div class="text-14">
            {{ isVerify && !isPerson ? '' : '1.'
            }}{{
              $t(
                'jin-zhi-chi-dian-zi-fa-piao-de-kai-ju-xin-xi-wu-wu-de-qing-kuang-xia-yu-ji-5-ge-gong-zuo-ri-nei-kai-ju-wan-cheng-bing-fa-song-zhi-nin-de-you-xiang'
              )
            }}
          </div>
          <div v-if="isPerson" class="text-14">
            2.{{ $t('ge-ren-yong-hu-jin-zhi-chi-kai-ju-pu-tong-fa-piao') }}
          </div>
          <div v-if="!isPerson && !isVerify" class="text-14">
            2.{{
              $t(
                'nin-de-tuan-dui-shang-wei-wan-cheng-ren-zheng-ren-zheng-wan-cheng-hou-ke-kai-ju-zeng-zhi-shui-zhuan-yong-fa-piao'
              )
            }}
            <NuxtLink
              :to="{
                name: PageKey.ACCOUNT_VERIFY,
              }"
            >
              {{ $t('qu-ren-zheng') }}>
            </NuxtLink>
          </div>
        </template>
      </a-alert>
    </div>
    <Detail :isPerson="isPerson" :isVerify="isVerify" />
  </PageContainer>
</template>

<script lang="ts" setup>
import Detail from './components/detail.vue'
import { USER_LEVEL_KEY } from '~/api/interface/auth'
import { PageKey } from '~/constants/page'
const { $t } = useNuxtApp()
const userInfo = useUserInfo()
const route = useRoute()

const separator = h('iconpark-icon', { name: 'breadcrumb-separator', size: 10 })

const isVerify = computed(() =>
  userInfo.value &&
  [
    USER_LEVEL_KEY.TASTE,
    USER_LEVEL_KEY.PERSONAL,
    USER_LEVEL_KEY.PERSONAL_LITE,
  ].includes(userInfo.value?.rights_type)
    ? true
    : Boolean(userInfo.value?.is_identify)
)

const isPerson = computed(() =>
  userInfo?.value?.rights_type
    ? [
        USER_LEVEL_KEY.TASTE,
        USER_LEVEL_KEY.PERSONAL,
        USER_LEVEL_KEY.PERSONAL_LITE,
      ].includes(Number(userInfo.value?.rights_type))
    : false
)
</script>
